import { useTranslation } from 'react-i18next'

import { TflStatus } from '@/features/view-tfl-uploaded/types'
import { cn } from '@/utils/common'

export type DocumentStatusVariant = TflStatus

export interface DocumentStatusProps {
  status: string
  variant?: DocumentStatusVariant
  className?: string
}

export const DocumentStatus = ({
  status,
  variant,
  className,
}: DocumentStatusProps) => {
  const { t } = useTranslation()

  const getStatusInfo = (): {
    variant: DocumentStatusVariant
    label: string
  } => {
    const statusLower = status.toLowerCase() as DocumentStatusVariant

    switch (statusLower) {
      case TflStatus.NEW:
        return {
          variant: TflStatus.NEW,
          label: t('tflViewer.documentTOC.status.newFile'),
        }
      case TflStatus.IN_REVIEW:
        return {
          variant: TflStatus.IN_REVIEW,
          label: t('tflViewer.documentTOC.status.inReview'),
        }
      case TflStatus.APPROVED:
        return {
          variant: TflStatus.APPROVED,
          label: t('tflViewer.documentTOC.status.approved'),
        }
      case TflStatus.QUERY_RAISED:
        return {
          variant: TflStatus.QUERY_RAISED,
          label: t('tflViewer.documentTOC.status.queryRaised'),
        }
      case TflStatus.UNDER_REVISION:
        return {
          variant: TflStatus.UNDER_REVISION,
          label: t('tflViewer.documentTOC.status.underRevision'),
        }
      default:
        return { variant: variant || TflStatus.NEW, label: status }
    }
  }

  const { variant: currentVariant, label } = getStatusInfo()

  const variantStyles: Record<DocumentStatusVariant, string> = {
    new: 'bg-purple-50 text-purple-700 border-purple-200',
    in_review: 'bg-warning-50 text-warning-700 border-warning-200',
    approved: 'bg-success-50 text-success-700 border-success-200',
    query_raised: 'bg-error-50 text-error-700 border-[--Colors-Error-200]',
    under_revision: 'bg-[--Colors-Gray-50] text-[#363F72] border-[#D5D9EB]',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center text-xs px-2 py-0.5 rounded-full font-medium border border-solid',
        variantStyles[currentVariant],
        className
      )}
    >
      {label}
    </span>
  )
}
